import React, { useState } from "react";

import ModalHolder from "../../molecules/ModalHolder";

import { P, H5 } from "../../atoms/Texts";

import { selectStyle } from "../../../shared/fixtures/select_style";

import { toastWarning } from "../../../shared/helpers";

import { PrimaryButton, OutlineButton } from "../../atoms/Buttons";

import sendInviteIcon from "../../../assets/images/sendInviteIcon.svg";
import { CustomSelectDropdown } from "../../atoms/Inputs";

const InitiativeSendInvite = ({ closeModal }) => {
  const [selected, setSelected] = useState(null);

  const options = [
    {
      value: "123yj8s67fgj4dfks9900fie",
      label: "Flaming Heart",
    },
    {
      value: "ee6723yj8s67fgj4dfks9900fie",
      label: "Stomach Infrastructure",
    },
  ];

  const handleSendInvite = () => {
    toastWarning("Can not perform this action on Demo mode");
    closeModal();
  };

  return (
    <ModalHolder width="500px" closeModal={closeModal}>
      <div className="bg-white">
        <img className="mb-4" src={sendInviteIcon} alt="send invite" />
        <H5 color="#101828" fontSize="28px" className="mb-2">
          Send invite
        </H5>

        <P color="#667085" fontSize="18px">
          Send an invite to join this initiative
        </P>

        <div className="w-full flex-grow mt-4">
          <div className="mb-8">
            <P color="#344054" fontSize="16px" className="mb-2">
              Search name of organization
            </P>

            <CustomSelectDropdown
              onChange={(selectedOption) => setSelected(selectedOption)}
              styles={selectStyle}
              placeholder=""
              options={options}
            />

            {/* <AsyncSelect
              styles={selectStyle}
              cacheOptions
              defaultOptions
              loadOptions={options}
              isLoading={loading}
              placeholder=""
              onChange={(selectedOption) => setSelected(selectedOption)}
            /> */}
          </div>
        </div>
      </div>

      <div className="pb-8">
        <div className="flex gap-4">
          <OutlineButton
            type="button"
            onClick={closeModal}
            color="#344054"
            border="2px solid #D0D5DD"
            className="w-full"
          >
            Cancel
          </OutlineButton>
          <PrimaryButton
            onClick={handleSendInvite}
            disabled={!selected}
            className="w-full"
          >
            Send invite
          </PrimaryButton>
        </div>
      </div>
    </ModalHolder>
  );
};

export default InitiativeSendInvite;
